import { render, staticRenderFns } from "./InventoryCount.vue?vue&type=template&id=28a3063d&scoped=true"
import script from "./InventoryCount.vue?vue&type=script&lang=js"
export * from "./InventoryCount.vue?vue&type=script&lang=js"
import style0 from "./InventoryCount.vue?vue&type=style&index=0&id=28a3063d&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3063d",
  null
  
)

export default component.exports